import { Injectable } from '@angular/core';
import { RestaurantService } from './restaurant.service';
import { ApiService } from './api.service';

/**
 * `providedIn: 'root'` em vez de entrada no `CoreModule.providers`: o singleton é o mesmo, mas
 * o bundler passa a colocar este serviço no chunk de quem o INJETA. Listado no CoreModule, ele
 * viajava no `main.js` do boot — e esta tela só aparece depois de vários gestos.
 */
@Injectable({ providedIn: 'root' })
export class JourneyService {
    private baseURL: string = '/restaurant';
    constructor(
        private restaurantService: RestaurantService,
        private apiService: ApiService
    ) {}

    getJourneyOrderByOrderUuid(orderUUID: string): Promise<any> {
        return new Promise((resolve, reject) => {
            this.apiService
                .get(
                    `${this.baseURL}/journey-orders/get-by-order-uuid?orderUUID=${orderUUID}`
                )
                .subscribe(
                    (data) => {
                        resolve(data);
                    },
                    (error) => {
                        reject(error);
                    }
                );
        });
    }
}
